import { render, staticRenderFns } from "./MentorsPage.vue?vue&type=template&id=cbe7894c&scoped=true&"
import script from "./MentorsPage.vue?vue&type=script&lang=js&"
export * from "./MentorsPage.vue?vue&type=script&lang=js&"
import style0 from "./MentorsPage.vue?vue&type=style&index=0&id=cbe7894c&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe7894c",
  null
  
)

export default component.exports